import { isFixedLayoutTemplate } from 'app/utils/utils';
import { CLIENT, LESSON_TYPES_IDS } from 'core/variables/constant';

type PowerLessonViewParams = {
  client?: string | null;
  /** `course.has_power_lesson` from the course detail (it is inherited from the program there). */
  hasPowerLesson?: number | boolean | null;
  lessonType?: string | null;
  /** `course.template.template_type` from the course detail. */
  templateType?: string | null;
};

/**
 * Whether a lesson opens with LessonViewPower — the only view where a teacher can add an HTML
 * (Mint) page. Same rules as the lesson pages: app/pages/LessonPage/LessonPage.js (fixed-layout
 * template, power course or power lesson; legacy Mint lessons have their own view) and
 * edelvives/pages/LessonPage/LessonPage.tsx, which only renders fixed or hybrid templates.
 * Keep them in sync.
 */
function shouldRenderPowerLessonView({ client, hasPowerLesson, lessonType, templateType }: PowerLessonViewParams): boolean {
  if (lessonType === LESSON_TYPES_IDS.MINT) return false;
  if (isFixedLayoutTemplate(templateType)) return true;
  if (client === CLIENT.EDELVIVES) return false;
  return Number(hasPowerLesson) === 1 || lessonType === LESSON_TYPES_IDS.POWER;
}

export default shouldRenderPowerLessonView;
